import { orderBy } from 'lodash';
import { useState } from 'react';
import Select from 'react-select';
import { Container, Col, Row } from 'react-bootstrap';
import { reactSelectStyle } from '@/config/model';
import { useModalAnimation } from '@/hooks/useModalAnimation';
import { pageKey } from '@/routes';

import Navbar from '../components/Navbar';

import {
  CompaniesList,
  TKCompanyModal,
  CompanyProfilesAddModal,
  useCompanyList,
  options,
  SelectValue,
} from '@/features/companies';

import { useUsers } from '@/features/users';

/**
 * ===== Company list & User list management page =======
 * @returns
 */
const CompanyProfiles = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    comnModalProps: commons,
    modalContex,
    activeModalType,
    activateModalBy: openBy,
  } = useModalAnimation();

  const { companiesByStatus, selectedOption, setSelectedOption } =
    useCompanyList();

  const userQuery = useUsers();

  const orderedUser = orderBy(userQuery.data, ['date_created'], ['desc']);

  return (
    <>
      <Container>
        <Row>
          <Col className="bg-dark sidebar d-flex flex-column">
            <Navbar activePage={pageKey.COMPANY} />
          </Col>

          <Col className="ms-6 me-4 ">
            <div className="d-flex flex-column align-items-center mt-4">
              {/* Page Title */}
              <h3 className="text-center">Company Management</h3>
              <div
                className="d-flex justify-content-end w-100"
                style={{ gap: '30px' }}
              >
                {/* === Company Display filter by status === */}
                <Select
                  defaultValue={selectedOption}
                  onChange={(value) => setSelectedOption(value as SelectValue)}
                  options={options}
                  styles={reactSelectStyle}
                />
                {/* === Create New Company === */}
                <button
                  className="btn btn-primary"
                  onClick={() => setIsModalOpen(true)}
                >
                  Add New Company
                </button>
              </div>
              {/* === Company list */}
              <div className="mt-4 p-0 container">
                {companiesByStatus ? (
                  <CompaniesList
                    openBy={openBy}
                    users={orderedUser}
                    companies={companiesByStatus}
                  />
                ) : (
                  <div>loading...</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
        {/* ===== USER TABLE ===== */}
      </Container>
      {/* === Add contributor === */}
      <TKCompanyModal
        type={activeModalType}
        props={{
          commons,
          extra: {
            companyId: modalContex.companyId,
            companyProfile: modalContex.companyProfile,
            userId: modalContex.userId,
            userName: modalContex.userName,
          },
        }}
      />
      {/* === Add company TODO: move this to `TKCompanyModal` === */}
      <CompanyProfilesAddModal
        show={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default CompanyProfiles;
